import areaData from './area.json';

function flattenAreaData(data) {
    let result = [];

    // 第一层 - 省份
    areaData.forEach(province => {
        result.push({
            name: province.name,
            code: province.code,
            level: 'province'
        });

        // 第二层 - 城市
        if (province.city) {
            province.city.forEach(city => {
                result.push({
                    name: city.name,
                    code: city.code,
                    parentCode: province.code,
                    level: 'city'
                });

                // 第三层 - 区域
                // if (city.area) {
                //     city.area.forEach(area => {
                //         result.push({
                //             name: area.name,
                //             code: area.code,
                //             parentCode: city.code,
                //             level: 'area'
                //         });
                //     });
                // }
            });
        }
    });

    return result;
}
let cachedAreas = null;
function getAreas() {
    if (!cachedAreas) {
        cachedAreas = flattenAreaData(areaData);
    }
    return cachedAreas;
}

export default flattenAreaData;


// WEBPACK FOOTER //
// ./src/assets/area.js